import React, { } from 'react';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import AddCircleOutline from '@material-ui/icons/AddCircleOutline';
import RefreshOutlined from '@material-ui/icons/RefreshOutlined';
import Visibility from '@material-ui/icons/Visibility';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChipInput from 'material-ui-chip-input';
import ColorPicker from 'material-ui-color-picker';
import Tooltip from '@material-ui/core/Tooltip';
import moment from 'moment';
import {
  apiRequest,
  apiBatchRequest
} from '../../../utils/api_service';
import { API_URL, createApiUrl } from '../../../constants/api';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
// import RenderLayout from "../../Dashboard/RenderLayout";
import Chip from '@material-ui/core/Chip';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Input from '@material-ui/core/Input';
import camelCaseKeys from 'camelcase-keys';
import { ShowToast, toastType } from '../../../utils/toast-service';
import { FormHelperText, TextareaAutosize } from '@material-ui/core';
// import DenseTable from "../../Dashboard/RenderTable";
// import { GetPropsForData } from "../../../utils/graph_service";
import { removeDuplicates, PaperComponent, getCurrentPayCycleEndDate, getCurrentPayCycleStartDate, buildWidgetUrlWithParameter } from '../../../utils/helper';
import RenderLayout from '../../Dashboard/RenderLayout';
import GridTable from '../Table/Table';
import { GetPropsForData } from '../../../utils/graph_service';
import { DataFormat, DataOperators, Operators } from '../../../constants/appConstants';
import { MdContentCopy } from 'react-icons/md';
import _ from 'lodash';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};
const colors = [
  '#D14040',
  '#7F40D1',
  '#2D76E5',
  '#1BBC86',
  '#E2E22D',
  '#92661A',
  '#EB9563',
  '#E5897F',
  '#E24E89',
  '#C063E8',
  '#63B3E8'
];

class Widget extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      masterConfig: undefined,
      chartConfig: this.props.chartConfig,
      sampleData: this.props.sampleData,
      sampleViewData: undefined,
      configuration: null,
      openPreview: false,
      openConfirmPreview: false,
      openViewSampleDataPanel: false,
      sourceList: [],
      param: {
        startDate: moment().subtract(6, 'month').format('MM/DD/yyyy'),
        endDate: moment().format('MM/DD/yyyy')
      },
      isSummaryData: false,
      isForPerformance: false,
      errors: { fields: [], columns: [], filters: [] }
    };
  }

  componentDidMount () {
    this.GetMasterData();
    if (this.props.chartConfig) {
      let configuration = this.props.chartConfig.configuration;
      if (configuration !== undefined) {
        configuration = JSON.parse(
          JSON.stringify(configuration || this.props.masterConfig.configuration)
        );
        configuration = JSON.parse(
          configuration || this.props.masterConfig.configuration
        );
      }
      const chartConfig = this.props.chartConfig;
      if (chartConfig.title === undefined) {
        chartConfig.title = this.props.masterConfig.name || '';
      }
      this.setState(
        {
          masterConfig: this.props.masterConfig,
          chartConfig: chartConfig,
          sampleData: this.props.sampleData,
          configuration: configuration || {}
        },
        () => {
          if (chartConfig.isForPerformance === true) {
            this.loadPerformanceAttribute(chartConfig.reportId);
          }
          if (
            this.props.addNew !== true &&
            (this.props.sampleData === undefined || this.props.sampleData === {})
          ) {
            if (chartConfig.dataUrl) {
              this.getDataSourceSample(chartConfig.dataUrl);
              this.SetIsSummaryData(chartConfig.dataUrl);
            }
          }
        }
      );
    }
  }

  handleTrendChange = (value, key) => {
    const configuration = this.state.configuration;
    if (configuration.trend === undefined) {
      configuration.trend = { type: '', key: '' };
    }
    configuration.trend[key] = value;
    this.setState(
      {
        configuration: configuration
      },
      () => this.isValidateConfiguration(false)
    );
  };

  handleSummaryFieldsConfigChange = (value, key) => {
    const configuration = this.state.configuration;
    if (configuration.summaryFieldsConfig === undefined) {
      configuration.summaryFieldsConfig = { };
    }
    configuration.summaryFieldsConfig[key] = value;
    this.setState(
      {
        configuration: configuration
      },
      () => this.isValidateConfiguration(false)
    );
  };

   handleWidgetDataMappingChange = (value, key) => {
     const configuration = this.state.configuration;
     if (configuration.widgetDataMapping === undefined) {
       configuration.widgetDataMapping = { };
     }
     configuration.widgetDataMapping[key] = value;
     this.setState(
       {
         configuration: configuration
       },
       () => this.isValidateConfiguration(false)
     );
   };

  handleExtraParameterChange = (value, key, index) => {
    const configuration = this.state.configuration;
    if (configuration.extraParameters === undefined) {
      configuration.extraParameters = [
        {
          parameterName: '',
          parameterValue: ''
        }
      ];
    }
    configuration.extraParameters[index][key] = value;
    this.setState({
      configuration: configuration
    });
  };

  AddExtraParameter = () => {
    const configuration = this.state.configuration;
    if (configuration.extraParameters === undefined) {
      configuration.extraParameters = [
        {
          parameterName: '',
          parameterValue: ''
        }
      ];
    } else {
      configuration.extraParameters.push({
        parameterName: '',
        parameterValue: ''
      });
    }
    this.setState({
      configuration: configuration
    });
  };

  handleChange = (value, key) => {
    const chartConfig = this.state.chartConfig;
    chartConfig[key] = value;
    this.setState(
      {
        chartConfig: chartConfig
      },
      () => this.isValidateConfiguration(false)
    );
  };

  handleConfigurationChange = (value, key) => {
    const configuration = this.state.configuration;
    configuration[key] = value;
    this.setState(
      {
        configuration: configuration
      },
      () => this.isValidateConfiguration(false)
    );
  };

  handleAutoGenerateColumnChange = (value, key) => {
    const configuration = this.state.configuration;
    if (configuration.autoGenerate === undefined) {
      configuration.autoGenerate = { key: '', filters: [], dataColumn: [] };
    }
    configuration.autoGenerate[key] = value;
    this.setState(
      {
        configuration: configuration
      },
      () => this.isValidateConfiguration(false)
    );
  };

  handleAutoGenerateDataColumnChange = (value, key, index) => {
    const configuration = this.state.configuration;
    if (configuration.autoGenerate === undefined) {
      configuration.autoGenerate = { key: '', filters: [], dataColumn: [] };
    }
    configuration.autoGenerate.dataColumn[index][key] = value;
    this.setState(
      {
        configuration: configuration
      },
      () => this.isValidateConfiguration(false)
    );
  };

  handleAutoGenerateAddDataColumn = () => {
    const configuration = this.state.configuration;
    if (configuration.autoGenerate === undefined) {
      configuration.autoGenerate = { key: '', filters: [], dataColumn: [] };
    }
    if (configuration.autoGenerate.dataColumn === undefined) {
      configuration.autoGenerate.dataColumn = [];
    }
    configuration.autoGenerate.dataColumn.push({ operator: '', key: '', title: '' });
    this.setState(
      {
        configuration: configuration
      },
      () => this.isValidateConfiguration(false)
    );
  };

  handleAutoGenerateDeleteDataColumn = (level) => {
    const configuration = this.state.configuration;
    if (configuration.autoGenerate === undefined) {
      configuration.autoGenerate = { key: '', filters: [], dataColumn: [] };
    }
    configuration.autoGenerate.dataColumn.splice(level, 1);
    this.setState(
      {
        configuration: configuration
      },
      () => this.isValidateConfiguration(false)
    );
  };

  handleColumnChange = (value, key, index) => {
    const configuration = this.state.configuration;
    configuration.columns[index][key] = value;
    this.setState(
      {
        configuration: configuration
      },
      () => this.isValidateConfiguration(false)
    );
  };

  handleFilterChange = (value, key, columnIndex, index) => {
    const configuration = this.state.configuration;
    if (columnIndex === 'autoGenerate') {
      configuration.autoGenerate.filters[index][key] = value;
    } else {
      configuration.columns[columnIndex].filters[index][key] = value;
    }
    this.setState(
      {
        configuration: configuration
      },
      () => this.isValidateConfiguration(false)
    );
  };

  handleFilterValueChange = (value, columnIndex, index) => {
    const { configuration } = this.state;
    if (columnIndex === 'autoGenerate') {
      configuration.autoGenerate.filters[index].values = value;
    } else {
      const flitters = configuration.columns[columnIndex].filters;
      flitters[index].values = value;
      configuration.columns[columnIndex].filters = flitters;
    }
    this.setState(
      {
        configuration: configuration
      },
      () => this.isValidateConfiguration(false)
    );
  };

  addNewColumn = () => {
    const { configuration } = this.state;
    if (configuration.columns === undefined) {
      configuration.columns = [];
    }
    configuration.columns.push({
      key: '',
      name: '',
      type: 'count',
      filters: [
        {
          key: '',
          values: []
        }
      ],
      color: '#E59400',
      sortOrder: 0
    });
    this.setState({
      configuration: configuration
    });
  };

   addNewLevel = () => {
     const { configuration } = this.state;
     if (configuration.drillDownConfig === undefined) {
       configuration.drillDownConfig = [];
     }
     configuration.drillDownConfig.push({ key: '' });
     this.setState({
       configuration: configuration
     });
   };

  handleDrillDownChange = (value, key, index) => {
    const configuration = this.state.configuration;
    configuration.drillDownConfig[index][key] = value;
    this.setState(
      {
        configuration: configuration
      },
      () => this.isValidateConfiguration(false)
    );
  };

  deleteColumn = (index) => {
    const configuration = this.state.configuration;
    configuration.columns.splice(index, 1);
    this.setState(
      {
        configuration: configuration
      },
      () => this.isValidateConfiguration(false)
    );
  };

  deleteLevel = (index) => {
    const configuration = this.state.configuration;
    configuration.drillDownConfig.splice(index, 1);
    this.setState(
      {
        configuration: configuration
      },
      () => this.isValidateConfiguration(false)
    );
  };

  cloneColumn = (index) => {
    const configuration = this.state.configuration;
    const newColumn = _.cloneDeep(configuration.columns[index]);

    if (newColumn) {
      configuration.columns.push(newColumn);
      this.setState(
        {
          configuration: configuration
        },
        () => this.isValidateConfiguration(false)
      );
    }
  };

  addNewColumnFilter = (index) => {
    const configuration = this.state.configuration;
    if (index === 'autoGenerate') {
      if (configuration.autoGenerate === undefined) { configuration.autoGenerate = { key: '', filters: [] }; }
      configuration.autoGenerate.filters.push({
        key: '',
        values: []
      });
    } else {
      configuration.columns[index].filters.push({
        key: '',
        values: []
      });
    }
    this.setState({
      configuration: configuration
    });
  };

  deleteFilter = (columnIndex, filterIndex) => {
    const configuration = this.state.configuration;
    if (columnIndex === 'autoGenerate') {
      ((configuration.autoGenerate || {}).filters || []).splice(filterIndex, 1);
    } else {
      configuration.columns[columnIndex].filters.splice(filterIndex, 1);
    }
    this.setState(
      {
        configuration: configuration
      },
      () => this.isValidateConfiguration(false)
    );
  };

  getDataSourceSample = (url, openViewSampleDataPanel = false) => {
    this.GetData(
      moment(getCurrentPayCycleStartDate()).format('MM/DD/yyyy'),
      moment(getCurrentPayCycleEndDate()).format('MM/DD/yyyy'),
      url,
      openViewSampleDataPanel
    );
  };

  GetData = (
    // propertyId,
    startDate,
    endDate,
    url = '',
    openViewSampleDataPanel = false
  ) => {
    // var configuration = this.state.configuration;

    const arg = [{ key: 'startDate', value: startDate }, { key: 'endDate', value: endDate }];
    // console.log("Sending", params, widgetconfig);
    if (url.length > 0) {
      apiBatchRequest([{
        url: createApiUrl(buildWidgetUrlWithParameter(url, arg)),
        // postBody: [],
        key: 'response'
      }]).then(({ response }) => {
        this.setState({
          sampleData: camelCaseKeys(response.data[0]),
          sampleViewData: camelCaseKeys(response.data.slice(0, 10)),
          openViewSampleDataPanel: openViewSampleDataPanel
          // configuration: configuration
        });
      });
    }
  };

  // GetData = (sourceName, sourceUrl, params){
  //   apiRequest({
  //     url: API_URL.
  //   })
  // }

  // GetDataFromDataSource = (sourceName,sourceUrl,parameter){
  //   apiRequest({
  //     url: sourceUrl,
  //     parameter,
  //     key: sourceName
  //   }).then(sourceName) => {
  //     this.setState({
  //       sourceName: sourceName;
  //     })
  //   }
  // }

  loadPerformanceAttribute = (reportId) => {
    const params = {
      // propertyId: 6,
      reportId: reportId
    };
    const { chartConfig } = this.state;
    chartConfig.reportId = reportId;
    apiRequest({
      url: API_URL.performance.GetPerformanceReportAttribute,
      params
    }).then(({ data: performanceReportAttribute }) => {
      let perfAttribute = [];
      perfAttribute = removeDuplicates(
        performanceReportAttribute
          .filter(function (x) {
            return x.isKeyAttribute === true;
          })
          .map((a) => ({
            attributeName: a.attributeName,
            attributeListId: a.attributeListId
          })),
        'attributeListId'
      );

      this.setState({
        performanceReportAttribute: perfAttribute,
        chartConfig: chartConfig
        // configuration: configuration
      });
    });
  };

  GetMasterData = () => {
    apiBatchRequest([
      {
        url: API_URL.Dashboard.GetWidgetMasterDataList,
        key: 'widgetMasterData'
      },
      {
        url: API_URL.Dashboard.GetWidgetSourceList,
        key: 'sourceList'
      }
    ]).then(
      ({ widgetMasterData, sourceList }) => {
        this.setState(
          {
            masterData: widgetMasterData.data,
            sourceList: sourceList.data
          },
          () => this.SetIsSummaryData(this.state.chartConfig.dataUrl)
        );
      }
    );
  };

  GetMasterDataByKey = (keyValue) => {
    const { masterData } = this.state;
    // console.log(keyValue);
    return (masterData || []).filter(function (v, i) {
      return v.key.toLowerCase() === keyValue.toLowerCase();
    });
  };

  handlePreviewClickOpen = () => {
    const configuration = this.state.configuration;
    const chartConfig = this.state.chartConfig;
    if (this.isValidateConfiguration(true) === true) {
      chartConfig.configuration = JSON.stringify(
        configuration || this.state.masterConfig.configuration
      );
      this.setState({ openPreview: true, chartConfig: chartConfig });
    }
  };

  handlePreviewClose = () => {
    this.setState({ openPreview: false });
  };

  handleConfirmPreviewClickOpen = () => {
    this.setState({ openPreview: false, openConfirmPreview: true });
  };

  handleConfirmPreviewClose = () => {
    this.setState({ openConfirmPreview: false, openPreview: true });
  };

  handleSampleDataViewClose = () => {
    this.setState({ openViewSampleDataPanel: false });
  };

  getInputForKey = (key, columnIndex, filterIndex, values) => {
    const options = this.GetMasterDataByKey(key);

    if (options !== undefined && options.length > 0) {
      const result = values.filter(function (v, i) {
        return options.find((value) => value.label === v);
      });
      if (result === undefined || result.length === 0) {
        values = [];
      }
      return (
        <FormControl
          key={
            'FormControl_multiple-master-label' + columnIndex + 'c' + filterIndex
          }
          style={{
            minWidth: 120,
            maxWidth: 300
          }}
          error={this.getFilterErrorStatus('key', filterIndex, columnIndex)}
        >
          <InputLabel
            error={this.getFilterErrorStatus('key', filterIndex, columnIndex)}
            helperText={
              this.getFilterErrorStatus('key', filterIndex, columnIndex) &&
              'Filter on values must be specified.'
            }
            id={'mutiple-master-label' + columnIndex + 'c' + filterIndex}
          >
            Value(s)
          </InputLabel>
          <Select
            labelId={'mutiple-master-label' + columnIndex + 'c' + filterIndex}
            id={'mutiple-master-select' + columnIndex + 'c' + filterIndex}
            multiple
            defaultChecked={values}
            defaultValue={values}
            error={this.getFilterErrorStatus('key', filterIndex, columnIndex)}
            helperText={
              this.getFilterErrorStatus('key', filterIndex, columnIndex) &&
              'Filter on values must be specified.'
            }
            onChange={(event) => {
              this.handleFilterValueChange(
                event.target.value,
                columnIndex,
                filterIndex
              );
            }}
            input={
              <Input
                key={
                  'mutiple-master-chipInput' + columnIndex + 'c' + filterIndex
                }
                id={
                  'mutiple-master-chipInput' + columnIndex + 'c' + filterIndex
                }
              />
            }
            renderValue={(selected) => (
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap'
                }}
              >
                {selected.map((value) => (
                  <Chip
                    key={'chip' + columnIndex + 'c' + filterIndex}
                    key={value}
                    label={value}
                    style={{ margin: 2 }}
                  />
                ))}
              </div>
            )}
            MenuProps={MenuProps}
          >
            {options.map((data, ic) => (
              <MenuItem
                key={'masteroption' + columnIndex + 'c' + filterIndex + ic}
                value={data.label}
              >
                {data.label}
              </MenuItem>
            ))}
          </Select>
          {this.getFilterErrorStatus('key', filterIndex, columnIndex) && (
            <FormHelperText>Filter on values must be specified.</FormHelperText>
          )}
        </FormControl>
      );
    }

    return (
      <ChipInput
        key={ChipInput + columnIndex + 'c' + filterIndex}
        id={ChipInput + columnIndex + 'c' + filterIndex}
        label="Value(s)"
        defaultValue={values}
        error={this.getFilterErrorStatus('key', filterIndex, columnIndex)}
        helperText={
          this.getFilterErrorStatus('key', filterIndex, columnIndex) &&
          'Filter on values must be specified.'
        }
        onChange={(chips) => {
          this.handleFilterValueChange([...chips], columnIndex, filterIndex);
        }}
      />
    );
  };

  SetIsSummaryData = (value) => {
    const { sourceList, chartConfig } = this.state;
    const source = (sourceList || []).find(
      (x) =>
        x.sourceName === value &&
        (x.isSummaryData === true || x.isPerformanceData === true)
    );
    let isSummaryData = false;
    let isForPerformance = false;
    if (source !== undefined) {
      if (source.isSummaryData === true) isSummaryData = true;
      if (source.isPerformanceData === true) isForPerformance = true;
      chartConfig.isForPerformance = isForPerformance;
    }
    if (isForPerformance === false) {
      this.getDataSourceSample(value);
    }
    this.setState({
      isSummaryData: isSummaryData,
      isForPerformance: isForPerformance,
      chartConfig: chartConfig
    });
  };

  isValidateConfiguration = (showToast) => {
    const { isSummaryData, isForPerformance, chartConfig, configuration } =
      this.state;
    const errors = { fields: [], columns: [], filters: [] };
    // console.log(chartConfig);
    if (chartConfig.widgetType === 10) {
      this.setState({ errors: { fields: [], columns: [], filters: [] } });
      return true;
    }

    const message = [];
    if (this.props.configureMaster === true) {
      if ((chartConfig.name || '') === '') {
        message.push(<li>Please enter widget name.</li>);
        errors.fields.push('name');
      }
    } else {
      if ((chartConfig.title || '') === '') {
        message.push(<li>Please enter widget title. </li>);
        errors.fields.push('title');
      }
    }
    if (this.props.configureMaster === true) {
      if (
        (chartConfig.minWidth || 0) === 0 ||
        (chartConfig.minHeight || 0) === 0 ||
        (chartConfig.minWidth || 0) > 12 ||
        (chartConfig.minHeight || 0) > 12
      ) {
        message.push(<li>Please enter valid width and height.</li>);
        if (
          (chartConfig.minWidth || 0) === 0 ||
          (chartConfig.minWidth || 0) > 12
        ) {
          errors.fields.push('minWidth');
        }
        if (
          (chartConfig.minHeight || 0) === 0 ||
          (chartConfig.minHeight || 0) > 12
        ) {
          errors.fields.push('minHeight');
        }
      }
    } else {
      if (
        (chartConfig.width || 0) === 0 ||
        (chartConfig.height || 0) === 0 ||
        (chartConfig.width || 0) > 12 ||
        (chartConfig.height || 0) > 12
      ) {
        message.push(<li>Please enter valid width and height.</li>);
        if ((chartConfig.width || 0) === 0 || (chartConfig.width || 0) > 12) {
          errors.fields.push('width');
        }
        if ((chartConfig.height || 0) === 0 || (chartConfig.height || 0) > 12) {
          errors.fields.push('height');
        }
      }
    }
    if (this.props.configureMaster === true) {
      if ((chartConfig.dataUrl || '') === '') {
        message.push(<li>Please select data source.</li>);
        errors.fields.push('dataUrl');
      }
    }

    if ((chartConfig.widgetType || '') === '') {
      message.push(<li>Please select widget type.</li>);
      errors.fields.push('widgetType');
    } else {
      if (chartConfig.widgetType > 3 && isForPerformance === false) {
        if (
          configuration.trend === undefined ||
          (configuration.trend.key || '') === ''
        ) {
          message.push(<li>Please select trend on field.</li>);
          errors.fields.push('trend');
        }

        (configuration.drillDownConfig || []).forEach((x, i) => {
          if (
            x.key === undefined ||
          (x.key || '') === ''
          ) {
            if (errors.drillDownConfig === undefined) {
              errors.drillDownConfig = [];
            }
            errors.drillDownConfig.push({ key: 'key', index: i });
          }
        });
        if ((errors.drillDownConfig || []).length > 0) {
          message.push(<li>Please select Drilldown on field.</li>);
        }
      }
    }

    if (isForPerformance === true) {
      if (chartConfig.reportId === undefined || configuration.reportId === 0) {
        message.push(<li>Please select performance view.</li>);
        errors.fields.push('reportId');
      }
      if (
        chartConfig.attributeId === undefined ||
        configuration.attributeId === 0
      ) {
        message.push(<li>Please select performance view attribute.</li>);
        errors.fields.push('attributeListId');
      }
    }
    if (configuration.summaryFieldsConfig) {
      if (configuration.summaryFieldsConfig.attributeName === undefined || configuration.summaryFieldsConfig.attributeName.length < 1) {
        message.push(<li>Please enter values for summary fields.</li>);
        errors.fields.push('attributeName');
      }
      if (configuration.summaryFieldsConfig.attributeValue === undefined || configuration.summaryFieldsConfig.attributeValue.length < 1) {
        message.push(<li>Please enter values for summary fields.</li>);
        errors.fields.push('attributeValue');
      }
    } else {
      message.push(<li>Please enter values for summary fields.</li>);
      errors.fields.push('attributeName');
      errors.fields.push('attributeValue');
    }
    if ((chartConfig.isConfigurable === true || chartConfig.widgetType === 3) && configuration.isMappingAvailable !== true) {
      if (configuration.isRepeated === true) {
        if (
          configuration.autoGenerate === undefined ||
          configuration.autoGenerate.key === ''
        ) {
          message.push(<li>Please select field for auto generate column.</li>);
          errors.fields.push('autoGenerate');
        }
      } else {
        if (
          configuration.columns === undefined ||
          configuration.columns.length === 0
        ) {
          message.push(<li>Please add column(s).</li>);
        } else {
          let isInvalidColumn = false;
          let isInvalidFilter = false;
          const columnLength = configuration.columns.length;
          const sortIndex = [];
          configuration.columns.map((col, index) => {
            if (((col.key || '') === '') & (col.type === 'Individual')) {
              isInvalidColumn = true;
              errors.columns.push({ key: 'key', index: index });
            }
            if ((col.name || '') === '') {
              isInvalidColumn = true;
              errors.columns.push({ key: 'name', index: index });
            }
            if (chartConfig.widgetType !== 3) {
              if (col.sortOrder > columnLength) {
                isInvalidColumn = true;
                errors.columns.push({ key: 'sortOrder', index: index });
              } else {
                if (sortIndex.find((x) => x === col.sortOrder) !== undefined) {
                  isInvalidColumn = true;
                  errors.columns.push({ key: 'sortOrder', index: index });
                } else {
                  sortIndex.push(col.sortOrder);
                }
              }
            }
            if (chartConfig.widgetType > 3) {
              (col.filters || []).map((fl, i) => {
                if ((fl.key || '') === '' || (fl.values || []).length === 0) {
                  isInvalidFilter = true;
                  if ((fl.key || '') === '') {
                    errors.filters.push({
                      key: 'key',
                      index: i,
                      columnIndex: index
                    });
                  }
                  if ((fl.values || []).length === 0) {
                    errors.filters.push({
                      key: 'values',
                      index: i,
                      columnIndex: index
                    });
                  }
                }
              });
            }
          });
          if (isInvalidColumn) {
            message.push(<li>Invalid column(s) configuration.</li>);
          }
          if (isInvalidFilter) {
            message.push(<li>Invalid filters(s) configuration.</li>);
          }
        }
      }
    }
    if (message.length > 0) {
      this.setState(
        { errors: errors },
        () => showToast && ShowToast(message, toastType.ERROR, 5000, 500)
      );
      return false;
    } else {
      this.setState({ errors: { fields: [], columns: [], filters: [] } });
      return true;
    }
  };

  getErrorStatus = (key) => {
    const { errors } = this.state;
    const isFound = ((errors || {}).fields || []).find((x) => x === key);
    if (isFound !== undefined) {
      return true;
    }
    return false;
  };

   getdrillDownConfigErrorStatus = (key, index) => {
     const { errors } = this.state;
     const isFound = ((errors || {}).drillDownConfig || []).find((x) => x.key === key && x.index === index);
     if (isFound !== undefined) {
       return true;
     }
     return false;
   };

getdataColumnErrorStatus = (key, index) => {
  const { errors } = this.state;
  const isFound = ((errors || {}).dataColumns || []).find((x) => x.key === key && x.index === index);
  if (isFound !== undefined) {
    return true;
  }
  return false;
};

  getColumnErrorStatus = (key, index) => {
    const { errors } = this.state;
    const isFound = ((errors || {}).columns || []).find((x) => x.key === key && x.index === index);
    if (isFound !== undefined) {
      return true;
    }
    return false;
  };

  getFilterErrorStatus = (key, index, columnIndex) => {
    const { errors } = this.state;
    const isFound = ((errors || {}).filters || []).find(
      (x) => x.key === key && x.index === index && x.columnIndex === columnIndex
    );
    if (isFound !== undefined) {
      return true;
    }
    return false;
  };

  ShowDataSourceSample = (dataUrl) => {
    const { sampleViewData } = this.state;
    if (sampleViewData === undefined) {
      this.getDataSourceSample(dataUrl, true);
    } else {
      this.setState({ openViewSampleDataPanel: true });
    }
  };

  getErrorStatus = (key) => {
    const { errors } = this.state;
    const isFound = errors.fields.find((x) => x === key);
    if (isFound !== undefined) {
      return true;
    }
    return false;
  };

  render () {
    const {
      masterConfig,
      chartConfig,
      sampleData,
      configuration,
      openPreview,
      sampleViewData,
      openConfirmPreview,
      openViewSampleDataPanel,
      param,
      sourceList,
      isSummaryData,
      isForPerformance,
      reportList,
      performanceReportAttribute
    } = this.state;
    return (
      <div className="configure-widget">
        {' '}
        {masterConfig && chartConfig && (
          <>
            {this.props.configureMaster !== true && (
              <div className="col-sm-12 ">
                <div className="widgetIcon col-sm-4"></div>
                <div className="widgetIcon col-sm-8">
                  <h1>{masterConfig.name}</h1>
                  <span>Type: {masterConfig.type}</span>
                  <p>{masterConfig.description}</p>
                </div>
              </div>
            )}
            <div className="widget-holder col-sm-11">
              <form noValidate autoComplete="off">
                <div className="row">
                  <fieldset className="col-sm-12">
                    <legend>General</legend>
                    <div className="row">
                      <div className="col-sm-12">
                        {this.props.configureMaster !== true && (
                          <TextField
                            size="small"
                            id="title"
                            error={this.getErrorStatus('title')}
                            helperText={
                              this.getErrorStatus('title') &&
                              'Title is mandatory'
                            }
                            defaultValue={
                              chartConfig.title || masterConfig
                            }
                            onChange={(event) => {
                              this.handleChange(event.target.value, 'title');
                            }}
                            label={'Override Title'}
                          />
                        )}
                        {this.props.configureMaster === true && (
                          <TextField
                            size="small"
                            id="title"
                            defaultValue={chartConfig.name}
                            onChange={(event) => {
                              this.handleChange(event.target.value, 'name');
                            }}
                            error={this.getErrorStatus('name')}
                            helperText={
                              this.getErrorStatus('name') && 'Name is mandatory'
                            }
                            label={'Widget Name'}
                          />
                        )}
                      </div>

                      {this.props.configureMaster !== true && (
                        <>
                          {' '}
                          <div className="col-sm-6">
                            <TextField
                              size="small"
                              id="Width"
                              defaultValue={
                                chartConfig.width || masterConfig.minWidth
                              }
                              onChange={(event) => {
                                this.handleChange(
                                  parseInt(event.target.value || 0),
                                  'width'
                                );
                              }}
                              label="Width"
                              error={this.getErrorStatus('width')}
                              helperText={
                                this.getErrorStatus('width') &&
                                'Width is mandatory. Value must be between 1-12'
                              }
                            />
                          </div>
                          <div className="col-sm-6">
                            <TextField
                              size="small"
                              id="Height"
                              defaultValue={
                                chartConfig.height || masterConfig.minHeight
                              }
                              onChange={(event) => {
                                this.handleChange(
                                  parseInt(event.target.value || 0),
                                  'height'
                                );
                              }}
                              label="Height"
                              error={this.getErrorStatus('height')}
                              helperText={
                                this.getErrorStatus('height') &&
                                'Height is mandatory. Value must be between 1-12'
                              }
                            />
                          </div>
                        </>
                      )}
                      {this.props.configureMaster === true && (
                        <>
                          <div className="col-sm-6">
                            <TextField
                              size="small"
                              id="MinWidth"
                              value={chartConfig.minWidth}
                              onChange={(event) => {
                                this.handleChange(
                                  parseInt(event.target.value || 0),
                                  'minWidth'
                                );
                              }}
                              label="Minimum Width"
                              error={this.getErrorStatus('minWidth')}
                              helperText={
                                this.getErrorStatus('minWidth') &&
                                'Minimum width is required. Value must be between 1-12'
                              }
                            />
                          </div>
                          <div className="col-sm-6">
                            <TextField
                              size="small"
                              id="MinHeight"
                              value={chartConfig.minHeight}
                              onChange={(event) => {
                                this.handleChange(
                                  parseInt(event.target.value || 0),
                                  'minHeight'
                                );
                              }}
                              label="Minimum Height"
                              error={this.getErrorStatus('minHeight')}
                              helperText={
                                this.getErrorStatus('minHeight') &&
                                'Minimum Height is required. Value must be between 1-12'
                              }
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </fieldset>
                  <fieldset className="col-sm-12">
                    <legend>
                      Data Source & type
                      {isForPerformance !== true && (
                        <>
                          <Tooltip title="View Sample Data">
                            <IconButton
                              aria-label={'refreshData'}
                              size="small"
                              onClick={() => {
                                this.ShowDataSourceSample(chartConfig.dataUrl);
                              }}
                            >
                              <Visibility fontSize="small" size="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Refresh Data Source">
                            <IconButton
                              aria-label={'refreshData'}
                              size="small"
                              onClick={() => {
                                this.getDataSourceSample(chartConfig.dataUrl);
                              }}
                            >
                              <RefreshOutlined fontSize="small" size="small" />
                            </IconButton>
                          </Tooltip>
                        </>
                      )}{' '}
                    </legend>
                    <div className="row">
                      <div className="col-sm-6">
                        {/* <TextField size="small" id="dataSource" value={masterConfig.dataUrl} label="Data source" /> */}
                        <FormControl
                          size="small"
                          error={this.getErrorStatus('dataUrl')}
                        >
                          <InputLabel size="small" id={'WidgetdataSourcelabel'}>
                            Type
                          </InputLabel>
                          <Select
                            size="small"
                            disabled={!this.props.configureMaster}
                            labelId={'WidgetdataSourcelabel'}
                            id={'WidgetdataSourceSelect'}
                            defaultValue={chartConfig.dataUrl}
                            error={this.getErrorStatus('dataUrl')}
                            helperText={
                              this.getErrorStatus('dataUrl') &&
                              'Data source is required.'
                            }
                            onChange={(event) => {
                              this.handleChange(event.target.value, 'dataUrl');
                              this.SetIsSummaryData(event.target.value);

                              this.getDataSourceSample(event.target.value);
                            }}
                          >
                            {sourceList &&
                              sourceList.map((key, ic) => {
                                return (
                                  <MenuItem
                                    size="small"
                                    key={'SourceName' + ic}
                                    title={key.description}
                                    value={key.sourceUrl + key.parameter}
                                  >
                                    {key.sourceName}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                          {this.getErrorStatus('dataUrl') && (
                            <FormHelperText>
                              Data source is required.
                            </FormHelperText>
                          )}
                        </FormControl>
                      </div>
                      <div className="col-sm-6">
                        <FormControl
                          size="small"
                          error={this.getErrorStatus('widgetType')}
                        >
                          <InputLabel size="small" id={'WidgetTypelabel'}>
                            Type
                          </InputLabel>
                          <Select
                            size="small"
                            labelId={'WidgetTypelabel'}
                            id={'WidgetTypelabelSelect'}
                            defaultValue={chartConfig.widgetType}
                            error={this.getErrorStatus('widgetType')}
                            helperText={
                              this.getErrorStatus('widgetType') &&
                              'Widget Type is required.'
                            }
                            onChange={(event) => {
                              this.handleChange(
                                event.target.value,
                                'widgetType'
                              );
                              if (event.target.value === 3) {
                                this.handleConfigurationChange(
                                  false,
                                  'isRepeated'
                                );
                              }
                              if (
                                event.target.value > 3 &&
                                isForPerformance === false
                              ) {
                                this.handleChange(true, 'isConfigurable');
                              }
                            }}
                          >
                             {/* {isForPerformance !== true && (
                              <MenuItem size="small" value={10}>
                               Approval Process{' '}
                              </MenuItem>
                             )}
                            {isForPerformance !== true && (
                              <MenuItem size="small" value={1}>
                                In Line Form{' '}
                              </MenuItem>
                            )}
                            {isForPerformance !== true && (
                              <MenuItem size="small" value={2}>
                                Key Value Form
                              </MenuItem>
                            )} */}
                            {isForPerformance !== true && (
                              <MenuItem size="small" value={3}>
                                Table
                              </MenuItem>
                            )}
                            {/* {isSummaryData === false && (
                              <MenuItem size="small" value={4}>
                                Multiline Chart
                              </MenuItem>
                            )} */}
                            {isForPerformance !== true &&
                              isSummaryData === false && (
                                <MenuItem size="small" value={5}>
                                  Bar Chart
                                </MenuItem>
                            )}
                            {isForPerformance !== true &&
                              isSummaryData === false && (
                                <MenuItem size="small" value={11}>
                                  Bar Line Chart
                                </MenuItem>
                            )}
                            {isForPerformance !== true &&
                              isSummaryData === false && (
                                <MenuItem size="small" value={6}>
                                  Donut Chart
                                </MenuItem>
                            )}
                            {isForPerformance !== true &&
                              isSummaryData === false && (
                                <MenuItem size="small" value={7}>
                                  Pie Chart
                                </MenuItem>
                            )}
                            {isSummaryData === false && (
                              <MenuItem size="small" value={8}>
                                Stack Bar Chart
                              </MenuItem>
                            )}
                            {isSummaryData === false && (
                              <MenuItem size="small" value={9}>
                                Group Bar Chart
                              </MenuItem>
                            )}
                            {/* <MenuItem size="small" value={10}>Map</MenuItem> */}
                          </Select>
                          {this.getErrorStatus('widgetType') && (
                            <FormHelperText>
                              Widget Type is required.
                            </FormHelperText>
                          )}
                        </FormControl>
                      </div>
                    </div>
                    {(chartConfig.widgetType === 4 ||
                      chartConfig.widgetType === 5 ||
                      chartConfig.widgetType === 6 ||
                      chartConfig.widgetType === 7 ||
                      chartConfig.widgetType === 8 ||
                      chartConfig.widgetType === 9) && (
                      <><div className="row">
                        <div className="col-sm-6">
                          <TextField
                            size="small"
                            id="dataSourceYAxisLabel"
                            value={configuration.yAxisLabel}
                            onChange={(event) => {
                              this.handleConfigurationChange(
                                event.target.value,
                                'yAxisLabel'
                              );
                            }}
                            label="Y Axis Label"
                          />
                          
                        </div>
                      <div className="col-sm-6">
                            <FormControl
                              size="small"
                              error={this.getErrorStatus('trend')}
                            >
                              <InputLabel
                                size="small"
                                id={'columnTrendkeylabel'}
                              >
                                Order By
                              </InputLabel>
                              <Select
                                required={true}
                                // error={((configuration.trend || {}).key||"")==""?true:false}
                                size="small"
                                labelId={'columnTrendkeylabel'}
                                id={'columnKeySelectOrderBy'}
                                error={this.getErrorStatus('orderBy')}
                                helperText={
                                  this.getErrorStatus('orderBy') &&
                                  'Order By on field is required.'
                                }
                                defaultValue={
                                    (configuration.orderBy || '')}
                                onChange={(event) => {
                                  this.handleConfigurationChange(
                                    event.target.value === ''
                                      ? undefined
                                      : event.target.value,
                                    'orderBy'
                                  );
                                }}
                              >
                                <MenuItem value="">
                                  <em>Default</em>
                              </MenuItem>
                              <MenuItem value="ASC">
                                  <em>Accending</em>
                              </MenuItem>
                              <MenuItem value="desc">
                                  <em>Descending</em>
                              </MenuItem>
                            </Select>
                              {this.getErrorStatus('orderBy') && (
                                <FormHelperText>
                                  Order By field is required.
                                </FormHelperText>
                              )}
                            </FormControl>
                          </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <FormControl size="small" required>
                                              <InputLabel
                                                size="small"
                                                id={
                                                  'axislabelOperator'
                                                }
                                              >
                                                Operator
                                              </InputLabel>
                                              <Select
                                                size="small"
                                                required
                                                labelId={
                                                  'axisfilterdatakeylabelOperator'
                                                }
                                                id={
                                                  'axisfilterdataKeySelectOperator'
                                                }
                                                value={configuration.operator}
                                                onChange={(event) => {
                                                  this.handleConfigurationChange(
                                                    event.target.value,
                                                    'operator'
                                                  );
                                                }}
                                              >
                                                <MenuItem value="">
                                                  <em>None</em>
                                                </MenuItem>
                                                {DataOperators &&
                                                  Object.keys(DataOperators).map(
                                                    (key, i) => (
                                                      <MenuItem
                                                        size="small"
                                                        value={key}
                                                        key={'axisDataColumnOperator' + i + key}
                                                      >
                                                        {key}
                                                      </MenuItem>
                                                    )
                                                  )}
                                              </Select>
                                            </FormControl>
                        </div>
                      <div className="col-sm-6">
                            <FormControl
                              size="small"
                            >
                              <InputLabel
                                size="small"
                                id={'axisdatacolumnconfigkeylabel'}
                              >
                                on Field
                              </InputLabel>
                              <Select
                                required={true}
                                // error={((configuration.trend || {}).key||"")==""?true:false}
                                size="small"
                                labelId={'axisdataColumnconfigkeylabel'}
                                id={'axisdataColumnconfigKeySelect'}
                                value={
                                  (configuration || {}).yAxiskey}
                                onChange={(event) => {
                                  this.handleConfigurationChange(
                                    event.target.value,
                                    'yAxiskey'
                                  );
                                }}
                              >
                                <MenuItem value="">
                                  <em>None</em>
                                </MenuItem>
                                {sampleData &&
                                  Object.keys(sampleData).map((key, ic) => {
                                    return (
                                      <MenuItem
                                        size="small"
                                        key={'axisdataColumnConfigtrendKey' + ic}
                                        value={key}
                                      >
                                        {key}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                            </FormControl>
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-sm-6'>
                            <FormControlLabel
                            id={'isConfigurablehideYAxisLabelControlLabel'}
                            key={'isConfigurablehideYAxisLabelControlLabelkey'}
                            value={chartConfig.hideXAxisLabel || false}
                            checked={configuration.hideXAxisLabel}
                            control={
                              <Checkbox
                                id={'isConfigurablehideYAxisLabel'}
                                key={'isConfigurablehideYAxisLabel'}
                                checked={configuration.hideXAxisLabel}
                                color="primary"
                                onChange={(event) => {
                                  this.handleConfigurationChange(
                                    event.target.checked,
                                    'hideXAxisLabel'
                                  );
                                }}
                              />
                            }
                            label="Hide XAxis"
                            labelPlacement="end"
                          />
                          </div>
                        </div>
                        </>
                    )}
                  </fieldset>
                  <fieldset className="col-sm-12">
                        <legend>Summary fields</legend>
                      <div className="row">
                        <div className="col-sm-6">
                           <TextField
                              size="small"
                              id="Summary Field Display name"
                              value={
                                (configuration.summaryFieldsConfig || {}).attributeName
                              }
                              onChange={(event) => {
                                this.handleSummaryFieldsConfigChange(
                                  event.target.value,
                                  'attributeName'
                                );
                              }}
                              label="Display name"
                              error={this.getErrorStatus('attributeName')}
                              helperText={
                                this.getErrorStatus('attributeName') &&
                                'Summary Field Display name is mandatory.'
                              }
                            /> </div>
                          <div className="col-sm-6">
                            <TextField
                              size="small"
                              id="Summary Count Display name"
                              value={
                                (configuration.summaryFieldsConfig || {}).attributeValue
                              }
                              onChange={(event) => {
                                this.handleSummaryFieldsConfigChange(
                                  event.target.value,
                                  'attributeValue'
                                );
                              }}
                              label="Count Display name"
                              error={this.getErrorStatus('attributeValue')}
                              helperText={
                                this.getErrorStatus('attributeName') &&
                                'Summary Count Display name is mandatory.'
                              }
                            />  </div>
                        </div>
                      </fieldset>
                   {/* <div className="col-sm-12">
                  <TextareaAutosize
                  aria-label={'ToolTipTemplate'}
                      label={'ToolTipTemplate'}
                  rowsMin={3}
                  style={{ width: '100%' }}
                  value={configuration.tooltipTemplate}
                      placeholder="TooltipTemplate"
                      onChange={(e) => {
                        this.handleConfigurationChange(
                          e.target.value,
                          'tooltipTemplate'
                        );
                      }}
                />
                          </div> */}

                  {chartConfig.widgetType !== 3 && chartConfig.widgetType !== 10 &&
                    isSummaryData === false &&
                    isForPerformance !== true && (
                      <fieldset className="col-sm-12">
                        <legend>Trend</legend>
                      <div className="row">
                        <div className="col-sm-6">
                            <FormControl
                              size="small"
                              error={this.getErrorStatus('trendType')}
                            >
                              <InputLabel
                                size="small"
                                id={'columnTrendTypekeylabel'}
                              >
                                Type
                              </InputLabel>
                              <Select
                                required={true}
                                // error={((configuration.trend || {}).key||"")==""?true:false}
                                size="small"
                                labelId={'columnTrendTypekeylabel'}
                                id={'columnKeyTendTypeSelect'}
                                error={this.getErrorStatus('trendType')}
                                helperText={
                                  this.getErrorStatus('trendType') &&
                                  'Trend type is required.'
                                }
                                defaultValue={
                                    (configuration.trend || {}).type}
                                onChange={(event) => {
                                  this.handleTrendChange(
                                    event.target.value,
                                    'type'
                                  );
                                }}
                              >
                                <MenuItem value="field">
                                  <em>By field</em>
                              </MenuItem>
                              <MenuItem value="date">
                                  <em>By Date</em>
                              </MenuItem>
                              <MenuItem value="YTD">
                                  <em>YTD</em>
                              </MenuItem>
                              <MenuItem value="Monthly">
                                  <em>Monthly</em>
                              </MenuItem>
                              <MenuItem value="Weekly">
                                  <em>Weekly</em>
                                </MenuItem>
                              <MenuItem value="date">
                                  <em>Yearly</em>
                              </MenuItem>
                              <MenuItem value="PayCycle">
                                  <em>By PayCycle</em>
                              </MenuItem>
                               <MenuItem value="Distinct">
                                  <em>Distinct Count On</em>
                                </MenuItem>
                                </Select>
                              {this.getErrorStatus('trendType') && (
                                <FormHelperText>
                                  Trend type is required.
                                </FormHelperText>
                              )}
                            </FormControl>
                          </div>
                          <div className="col-sm-6">
                            <FormControl
                              size="small"
                              error={this.getErrorStatus('trend')}
                            >
                              <InputLabel
                                size="small"
                                id={'columnTrendkeylabel'}
                              >
                                on Field
                              </InputLabel>
                              <Select
                                required={true}
                                // error={((configuration.trend || {}).key||"")==""?true:false}
                                size="small"
                                labelId={'columnTrendkeylabel'}
                                id={'columnKeySelect'}
                                error={this.getErrorStatus('trend')}
                                helperText={
                                  this.getErrorStatus('trend') &&
                                  'Trend on field is required.'
                                }
                                defaultValue={
                                    (configuration.trend || {}).key}
                                onChange={(event) => {
                                  this.handleTrendChange(
                                    event.target.value,
                                    'key'
                                  );
                                }}
                              >
                                <MenuItem value="">
                                  <em>None</em>
                                </MenuItem>
                                {sampleData &&
                                  Object.keys(sampleData).map((key, ic) => {
                                    return (
                                      <MenuItem
                                        size="small"
                                        key={'trendKey' + ic}
                                        value={key}
                                      >
                                        {key}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                              {this.getErrorStatus('trend') && (
                                <FormHelperText>
                                  Trend on field is required.
                                </FormHelperText>
                              )}
                            {((configuration || {}).trend || {}).type !== 'field' &&
                              ((configuration || {}).trend || {}).type !== 'Distinct' &&
                              (<FormHelperText>
                              **Selected field should be of type Date
                            </FormHelperText>)
                            }
                            </FormControl>
                          </div>
                        </div>
                      </fieldset>
                  )}

                  {this.props.configureMaster === true && chartConfig.widgetType !== 10 &&
                    isForPerformance === false &&
                    (isSummaryData === false || chartConfig.widgetType === 3) && (
                      <>
                        <div className="col-sm-12">
                          <FormControlLabel
                            id={'isConfigurableControlLabel'}
                            key={'isConfigurableControlLabelkey'}
                            value={chartConfig.isConfigurable || false}
                            checked={chartConfig.isConfigurable}
                            control={
                              <Checkbox
                                id={'isConfigurableCheckbox'}
                                key={'isConfigurableCheckbox'}
                                checked={chartConfig.isConfigurable}
                                color="primary"
                                onChange={(event) => {
                                  this.handleChange(
                                    event.target.checked,
                                    'isConfigurable'
                                  );
                                }}
                              />
                            }
                            label="Is Configurable"
                            labelPlacement="end"
                          />
                        </div>
                       <div className="col-sm-12">
                          <FormControlLabel
                            id={'isWidgetMappingControlLabel'}
                            key={'isWidgetMappingControlLabelkey'}
                            value={configuration.isMappingAvailable || false}
                            checked={configuration.isMappingAvailable}
                            control={
                              <Checkbox
                                id={'isWidgetMappingControlCheckbox'}
                                key={'isWidgetMappingControlCheckbox'}
                                checked={configuration.isMappingAvailable}
                                color="primary"
                                onChange={(event) => {
                                  this.handleConfigurationChange(
                                    event.target.checked,
                                    'isMappingAvailable'
                                  );
                                }}
                              />
                            }
                            label="Is Based on data source Mapping"
                            labelPlacement="end"
                          />
                        </div>
                      </>
                  )}
                  {chartConfig.isForPerformance === true && chartConfig.widgetType !== 10 && (
                    <>
                      <fieldset className="col-sm-12">
                        <legend>Performance View</legend>
                        <div className="row">
                          <div className="col-sm-6">
                            <FormControl
                              size="small"
                              error={this.getErrorStatus('reportId')}
                            >
                              <InputLabel
                                size="small"
                                id={'columnReportIdKeylabel'}
                              >
                                View Name
                              </InputLabel>
                              <Select
                                required={true}
                                size="small"
                                labelId={'columnReportIdKeylabel'}
                                id={'columnReportIdKeySelect'}
                                error={this.getErrorStatus('reportId')}
                                helperText={
                                  this.getErrorStatus('reportId') &&
                                  'Performance view is required.'
                                }
                                defaultValue={chartConfig.reportId || 0}
                                onChange={(event) => {
                                  this.loadPerformanceAttribute(
                                    event.target.value
                                  );
                                }}
                              >
                                <MenuItem value={0}>
                                  <em>None</em>
                                </MenuItem>
                                {reportList &&
                                  reportList.map((key, ic) => {
                                    return (
                                      <MenuItem
                                        size="small"
                                        key={'trendKey' + ic}
                                        value={key.reportId}
                                      >
                                        {key.reportName}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                              {this.getErrorStatus('reportId') && (
                                <FormHelperText>
                                  Performance View is required.
                                </FormHelperText>
                              )}
                            </FormControl>
                          </div>
                          <div className="col-sm-6">
                            <FormControl
                              size="small"
                              error={this.getErrorStatus('attributeId')}
                            >
                              <InputLabel
                                size="small"
                                id={'columnReportAttributeKeylabel'}
                              >
                                View Attribute
                              </InputLabel>
                              <Select
                                required={true}
                                size="small"
                                labelId={'columnReportAttributeKeylabel'}
                                id={'columnReportAttributeKeySelect'}
                                error={this.getErrorStatus('attributeId')}
                                helperText={
                                  this.getErrorStatus('attributeId') &&
                                  'Attribute is required.'
                                }
                                value={chartConfig.attributeId || 0}
                                onChange={(event) => {
                                  this.handleChange(
                                    event.target.value,
                                    'attributeId'
                                  );
                                }}
                              >
                                <MenuItem value={0}>
                                  <em>None</em>
                                </MenuItem>
                                {performanceReportAttribute &&
                                  performanceReportAttribute.map((key, ic) => {
                                    return (
                                      <MenuItem
                                        size="small"
                                        key={'trendKey' + ic}
                                        value={key.attributeListId}
                                      >
                                        {key.attributeName}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                              {this.getErrorStatus('attributeId') && (
                                <FormHelperText>
                                  Attribute is required.
                                </FormHelperText>
                              )}
                            </FormControl>
                          </div>
                        </div>
                      </fieldset>
                    </>
                  )}
                  {chartConfig.isConfigurable === true && chartConfig.widgetType !== 10 &&
                    isForPerformance === false && (
                      <>
                      {chartConfig.widgetType !== 3 && (
                        <>
                          <div className="col-sm-6">
                          <FormControlLabel
                            id={'RepeatFormControlLabel'}
                            key={'RepeatFormControlLabelkey'}
                            value={configuration.isRepeated || false}
                            checked={configuration.isRepeated}
                            control={
                              <Checkbox
                                id={'RepeatCheckbox'}
                                checked={configuration.isRepeated}
                                color="primary"
                                onChange={(event) => {
                                  this.handleConfigurationChange(
                                    event.target.checked,
                                    'isRepeated'
                                  );
                                }}
                              />
                            }
                            label="Auto Generate columns Group By Field value"
                            labelPlacement="end"
                          />
                        </div>
                      </>

                      )}
                        {configuration.isRepeated === true &&
                          isForPerformance === false && (
                            <fieldset className="col-sm-12">
                              <legend>Columns (Auto)</legend>

                              <div className="row col-sm-12">
                                <div className="col-sm-6">
                                  <FormControl
                                    size="small"
                                    error={this.getErrorStatus('autoGenerate')}
                                  >
                                    <InputLabel
                                      size="small"
                                      id={'autoGeneratecolumnkeylabel'}
                                    >
                                      Field
                                    </InputLabel>
                                    <Select
                                      size="small"
                                      labelId={'autoGenerateColumnkeylabel'}
                                      id={'autoGenerateColumnKeySelect'}
                                      value={
                                        (configuration.autoGenerate || {}).key
                                      }
                                      error={this.getErrorStatus(
                                        'autoGenerate'
                                      )}
                                      helperText={
                                        this.getErrorStatus('autoGenerate') &&
                                        'AutoGenerate on field is required.'
                                      }
                                      onChange={(event) => {
                                        this.handleAutoGenerateColumnChange(
                                          event.target.value,
                                          'key'
                                        );
                                      }}
                                    >
                                      <MenuItem value="">
                                        <em>None</em>
                                      </MenuItem>
                                      {sampleData &&
                                        Object.keys(sampleData).map(
                                          (key, index) => {
                                            return (
                                              <MenuItem
                                                key={'AutoKeyFieldkey' + index}
                                                size="small"
                                                value={key}
                                              >
                                                {key}
                                              </MenuItem>
                                            );
                                          }
                                        )}
                                    </Select>
                                    {this.getErrorStatus('autoGenerate') && (
                                      <FormHelperText>
                                        AutoGenerate on field is required.
                                      </FormHelperText>
                                    )}
                                  </FormControl>
                                </div>
                                <div className="col-sm-6">
                          <TextField
                            size="small"
                            id="autoGeneratekeytitle"
                            key="autoGeneratekeytitle"
                            error={this.getErrorStatus('autoGenerate')}
                            helperText={
                              this.getdrillDownConfigErrorStatus('autoGenerate') &&
                              'Title is mandatory'
                            }
                           value={
                                        (configuration.autoGenerate || {}).title
                                      }
                                onChange={(event) => {
                                  this.handleAutoGenerateColumnChange(
                                    event.target.value,
                                    'title'
                                  );
                                }}
                            label={'Title'}
                          />
                                          </div>

                                <fieldset className="col-sm-12">
                                  <legend>
                                    Apply Filter
                                    <Tooltip title="Add New Filter">
                                      <IconButton
                                        aria-label={'autoGeneratefilter'}
                                        size="small"
                                        onClick={() =>
                                          this.addNewColumnFilter(
                                            'autoGenerate'
                                          )
                                        }
                                      >
                                        <AddCircleOutline fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                  </legend>
                                  {(
                                    (configuration.autoGenerate || {})
                                      .filters || []
                                  ).map((filter, filterIndex) => {
                                    return (
                                      <>
                                        <div className="row">
                                          <div className="col-sm-1 no-padding">
                                            <Tooltip title="Remove Filter">
                                              <IconButton
                                                aria-label={
                                                  'autoGenerateDeleteFilter' +
                                                  filterIndex
                                                }
                                                size="small"
                                                onClick={() =>
                                                  this.deleteFilter(
                                                    'autoGenerate',
                                                    filterIndex
                                                  )
                                                }
                                              >
                                                <DeleteIcon
                                                  style={{
                                                    color:
                                                      'var(--common--Text--color)'
                                                  }}
                                                  fontSize="small"
                                                />
                                              </IconButton>
                                            </Tooltip>
                                          </div>
                                          <div className="col-sm-4">
                                            <FormControl size="small" required>
                                              <InputLabel
                                                size="small"
                                                id={
                                                  'autoGeneratefilterkeylabel' +
                                                  filterIndex
                                                }
                                              >
                                                On
                                              </InputLabel>
                                              <Select
                                                size="small"
                                                required
                                                labelId={
                                                  'autoGeneratefilterkeylabel' +
                                                  filterIndex
                                                }
                                                id={
                                                  'autoGeneratefilterKeySelect' +
                                                  filterIndex
                                                }
                                                value={filter.key}
                                                onChange={(event) => {
                                                  this.handleFilterChange(
                                                    event.target.value,
                                                    'key',
                                                    'autoGenerate',
                                                    filterIndex
                                                  );
                                                }}
                                              >
                                                <MenuItem value="">
                                                  <em>None</em>
                                                </MenuItem>
                                                {sampleData &&
                                                  Object.keys(sampleData).map(
                                                    (key) => {
                                                      return (
                                                        <MenuItem
                                                          key={'autoGenerate' + 'Menu' + key}
                                                          size="small"
                                                          value={key}
                                                        >
                                                          {key}
                                                        </MenuItem>
                                                      );
                                                    }
                                                  )}
                                              </Select>
                                            </FormControl>
                                          </div>
                                         <div className="col-sm-4">
                                            <FormControl size="small" required>
                                              <InputLabel
                                                size="small"
                                                id={
                                                  'autoGeneratefilterkeylabelOperator' +
                                                  filterIndex
                                                }
                                              >
                                                Operator
                                              </InputLabel>
                                              <Select
                                                size="small"
                                                required
                                                labelId={
                                                  'autoGeneratefilterkeylabelOperator' +
                                                  filterIndex
                                                }
                                                id={
                                                  'autoGeneratefilterKeySelectOperator' +
                                                  filterIndex
                                                }
                                                value={filter.operator}
                                                onChange={(event) => {
                                                  this.handleFilterChange(
                                                    event.target.value,
                                                    'operator',
                                                    'autoGenerate',
                                                    filterIndex
                                                  );
                                                }}
                                              >
                                                <MenuItem value="">
                                                  <em>None</em>
                                                </MenuItem>
                                                {Operators &&
                                                  Object.keys(Operators).map(
                                                    (key, i) => (
                                                      <MenuItem
                                                        size="small"
                                                        value={key}
                                                        key={'Operator' + i + key}
                                                      >
                                                        {key}
                                                      </MenuItem>
                                                    )
                                                  )}
                                              </Select>
                                            </FormControl>
                                          </div>
                                          <div className="col-sm-4">
                                            {this.getInputForKey(
                                              filter.key,
                                              'autoGenerate',
                                              filterIndex,
                                              filter.values
                                            )}
                                            {/* <ChipInput
                                                                                label='Filter On'
                                                                                defaultValue={filter.values}
                                                                                onChange={(chips) => this.handleFilterChange(chips, "key", columnIndex, filterIndex)}
                                                                            /> */}
                                          </div>
                                        </div>
                                      </>
                                    );
                                  })}
                                </fieldset>
                          </div>
                           <div className="row">

                           <div className="col-sm-6">
                          <FormControlLabel
                            id={'switchtoLevel2'}
                            key={'switchtoLevel2LabelKey'}
                                value={(configuration.autoGenerate || {}).autoSwitch || false}
                            checked={configuration.isRepeated}
                            control={
                              <Checkbox
                                id={'switchtoLevelCheckbox'}
                                checked={(configuration.autoGenerate || {}).autoSwitch || false}
                                color="primary"
                                onChange={(event) => {
                                  this.handleAutoGenerateColumnChange(
                                    event.target.checked,
                                    'autoSwitch'
                                  );
                                }}
                              />
                            }
                            label="Auto Switch To Next Level If Group Count is 1"
                            labelPlacement="end"
                          />
                            </div>
                            <div className="col-sm-6">
                               <TextField
                      id="SecondLevelTitle"
                      value={(configuration.autoGenerate || {}).secondLevelTitle || ''}
                      onChange={(event) => {
                        this.handleAutoGenerateColumnChange(event.target.value, 'secondLevelTitle');
                      }}
                      label="Override Widget Heading"
                    />
                            </div>
                           </div>
                            </fieldset>
                        )}

                        {!configuration.isRepeated &&
                          isForPerformance === false && configuration.isMappingAvailable !== true && (
                            <fieldset className="col-sm-12">
                              <legend>
                                Columns
                                <Tooltip title="Add New Column">
                                  <IconButton
                                    aria-label={'addColumn'}
                                    size="small"
                                    onClick={this.addNewColumn}
                                  >
                                    <AddCircleOutline fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </legend>

                              {configuration.columns &&
                                configuration.columns.map((column, index) => {
                                  const columnIndex = index;
                                  return (
                                    <>
                                      <Accordion>
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls={
                                            'Column-content' + index
                                          }
                                          id={'panel-header' + index}
                                        >
                                          <Typography>
                                            <Tooltip title="Delete">
                                              <IconButton
                                                aria-label={
                                                  'delete' + columnIndex
                                                }
                                                size="small"
                                                onClick={() =>
                                                  this.deleteColumn(columnIndex)
                                                }
                                              >
                                                <DeleteIcon
                                                  style={{
                                                    color:
                                                      'var(--common--Text--color)'
                                                  }}
                                                  fontSize="small"
                                                />
                                              </IconButton>
                                            </Tooltip>{' '}
                                            &nbsp;Column {index + 1}
                                           <Tooltip title="Clone column">
                                              <IconButton
                                                aria-label={
                                                  'clone' + columnIndex
                                                }
                                                size="small"
                                                onClick={() =>
                                                  this.cloneColumn(columnIndex)
                                                }
                                              >
                                                <MdContentCopy
                                                  style={{
                                                    color:
                                                      'var(--common--Text--color)'
                                                  }}
                                                  fontSize="small"
                                                />
                                              </IconButton>
                                            </Tooltip>{' '}
                                           </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                          <div className="row col-sm-12">
                                            {chartConfig.widgetType !== 3 && (
                                              <div className="col-sm-6">
                                                <FormControl size="small">
                                                  <InputLabel
                                                    size="small"
                                                    id={
                                                      'columnTypelabel' + index
                                                    }
                                                  >
                                                    Type
                                                  </InputLabel>
                                                  <Select
                                                    size="small"
                                                    labelId={
                                                      'columnTypelabel' + index
                                                    }
                                                    id={
                                                      'columnTypeSelect' + index
                                                    }
                                                    defaultValue={column.type}
                                                    value={column.type}
                                                    onChange={(event) => {
                                                      this.handleColumnChange(
                                                        event.target.value,
                                                        'type',
                                                        index
                                                      );
                                                    }}
                                                  >
                                                    <MenuItem
                                                      size="small"
                                                      value={'count'}
                                                    >
                                                      Count
                                                    </MenuItem>
                                                    <MenuItem
                                                      size="small"
                                                      value={'Individual'}
                                                    >
                                                      Individual
                                                    </MenuItem>
                                                  </Select>
                                                </FormControl>
                                              </div>
                                            )}
                                            <div className="col-sm-6">
                                              <FormControl
                                                size="small"
                                                error={this.getColumnErrorStatus(
                                                  'key',
                                                  index
                                                )}
                                              >
                                                <InputLabel
                                                  size="small"
                                                  id={'columnkeylabel' + index}
                                                >
                                                  Field
                                                </InputLabel>
                                                <Select
                                                  size="small"
                                                  labelId={
                                                    'columnkeylabel' + index
                                                  }
                                                  id={'columnKeySelect' + index}
                                                  defaultValue={column.key}
                                                  value={column.key}
                                                  error={this.getColumnErrorStatus(
                                                    'key',
                                                    index
                                                  )}
                                                  helperText={
                                                    this.getColumnErrorStatus(
                                                      'key',
                                                      index
                                                    ) &&
                                                    'Column field must be selected.'
                                                  }
                                                  onChange={(event) => {
                                                    this.handleColumnChange(
                                                      event.target.value,
                                                      'key',
                                                      index
                                                    );
                                                  }}
                                                >
                                                  <MenuItem value="">
                                                    <em>None</em>
                                                  </MenuItem>
                                                  {sampleData &&
                                                    Object.keys(sampleData).map(
                                                      (key, index) => (
                                                        <MenuItem
                                                          size="small"
                                                          value={key}
                                                          key={'sampleKey' + index + key}
                                                        >
                                                          {key}
                                                        </MenuItem>
                                                      )
                                                    )}
                                                </Select>
                                                {this.getColumnErrorStatus(
                                                  'key',
                                                  index
                                                ) && (
                                                  <FormHelperText>
                                                    Column field must be
                                                    selected.
                                                  </FormHelperText>
                                                )}
                                              </FormControl>
                                            </div>
                                            <div className="col-sm-6">
                                              <TextField
                                                size="small"
                                                id={'name' + index}
                                                defaultValue={column.name}
                                                value={column.name}
                                                error={this.getColumnErrorStatus(
                                                  'name',
                                                  index
                                                )}
                                                helperText={
                                                  this.getColumnErrorStatus(
                                                    'name',
                                                    index
                                                  ) &&
                                                  'Column name must be specified.'
                                                }
                                                onChange={(event) => {
                                                  this.handleColumnChange(
                                                    event.target.value,
                                                    'name',
                                                    index
                                                  );
                                                }}
                                                label="Display Name"
                                              />
                                            </div>

                                            {chartConfig.widgetType !== 3 && (
                                              <>
                                                {' '}
                                                <div
                                                  className="col-sm-3"
                                                  style={{
                                                    backgroundColor:
                                                      column.color
                                                  }}
                                                >
                                                  <ColorPicker
                                                    key={'color' + index}
                                                    id={'color' + index}
                                                    name="color"
                                                    label="Color"
                                                    value={
                                                      column.color ||
                                                      colors[index]
                                                    }
                                                    // value={column.color} //- for controlled component
                                                    // onChange={color => console.log(color)}
                                                    onChange={(color) =>
                                                      this.handleColumnChange(
                                                        color,
                                                        'color',
                                                        index
                                                      )
                                                    }
                                                  />
                                                </div>
                                                <div className="col-sm-3">
                                                  <TextField
                                                    size="small"
                                                    id={'sortOrder' + index}
                                                    defaultValue={
                                                      column.sortOrder
                                                    }
                                                    error={this.getColumnErrorStatus(
                                                      'sortOrder',
                                                      index
                                                    )}
                                                    type="number"
                                                    helperText={
                                                      this.getColumnErrorStatus(
                                                        'sortOrder',
                                                        index
                                                      ) && 'Invalid sort order.'
                                                    }
                                                    onChange={(event) => {
                                                      this.handleColumnChange(
                                                        event.target.value,
                                                        'sortOrder',
                                                        index
                                                      );
                                                    }}
                                                    label="Sort Order"
                                                  />
                                                </div>
                                              </>
                                            )}
                                            {chartConfig.widgetType !== 3 &&
                                              column.type === 'count' && (
                                                <fieldset className="col-sm-12">
                                                  <legend>
                                                    Apply Filter
                                                    <Tooltip title="Add New Filter">
                                                      <IconButton
                                                        aria-label={
                                                          'filter' + columnIndex
                                                        }
                                                        size="small"
                                                        onClick={() =>
                                                          this.addNewColumnFilter(
                                                            columnIndex
                                                          )
                                                        }
                                                      >
                                                        <AddCircleOutline fontSize="small" />
                                                      </IconButton>
                                                    </Tooltip>
                                                  </legend>
                                                  {column.filters.map(
                                                    (filter, filterIndex) => {
                                                      return (
                                                        <>
                                                          <div className="row">
                                                            <div className="col-sm-1 no-padding">
                                                              <Tooltip title="Remove Filter">
                                                                <IconButton
                                                                  aria-label={
                                                                    'deleteFilter' +
                                                                    +columnIndex +
                                                                    'C' +
                                                                    filterIndex
                                                                  }
                                                                  size="small"
                                                                  onClick={() =>
                                                                    this.deleteFilter(
                                                                      columnIndex,
                                                                      filterIndex
                                                                    )
                                                                  }
                                                                >
                                                                  <DeleteIcon
                                                                    style={{
                                                                      color:
                                                                        'var(--common--Text--color)'
                                                                    }}
                                                                    fontSize="small"
                                                                  />
                                                                </IconButton>
                                                              </Tooltip>
                                                            </div>
                                                            <div className="col-sm-5">
                                                              <FormControl
                                                                size="small"
                                                                error={this.getFilterErrorStatus(
                                                                  'key',
                                                                  filterIndex,
                                                                  columnIndex
                                                                )}
                                                              >
                                                                <InputLabel
                                                                  size="small"
                                                                  id={
                                                                    'filterkeylabel' +
                                                                    columnIndex +
                                                                    'C' +
                                                                    filterIndex
                                                                  }
                                                                >
                                                                  On
                                                                </InputLabel>
                                                                <Select
                                                                  size="small"
                                                                  labelId={
                                                                    'filterkeylabel' +
                                                                    +columnIndex +
                                                                    'C' +
                                                                    filterIndex
                                                                  }
                                                                  id={
                                                                    'filterKeySelect' +
                                                                    +columnIndex +
                                                                    'C' +
                                                                    filterIndex
                                                                  }
                                                                  defaultValue={
                                                                    filter.key
                                                                  }
                                                                  error={this.getFilterErrorStatus(
                                                                    'key',
                                                                    filterIndex,
                                                                    columnIndex
                                                                  )}
                                                                  helperText={
                                                                    this.getFilterErrorStatus(
                                                                      'key',
                                                                      filterIndex,
                                                                      columnIndex
                                                                    ) &&
                                                                    'Filter on field must be selected.'
                                                                  }
                                                                  onChange={(
                                                                    event
                                                                  ) => {
                                                                    this.handleFilterChange(
                                                                      event
                                                                        .target
                                                                        .value,
                                                                      'key',
                                                                      columnIndex,
                                                                      filterIndex
                                                                    );
                                                                  }}
                                                                >
                                                                  <MenuItem value="">
                                                                    <em>
                                                                      None
                                                                    </em>
                                                                  </MenuItem>
                                                                  {sampleData &&
                                                                    Object.keys(
                                                                      sampleData
                                                                    ).map(
                                                                      (key, i) => (
                                                                        <MenuItem
                                                                          size="small"
                                                                          value={key}
                                                                          key={'sampledataforFilter' + columnIndex + '_' + filterIndex + '_' + i + key}
                                                                        >
                                                                          {key}
                                                                        </MenuItem>
                                                                      )
                                                                    )}
                                                                </Select>
                                                                {this.getFilterErrorStatus(
                                                                  'key',
                                                                  filterIndex,
                                                                  columnIndex
                                                                ) && (
                                                                  <FormHelperText>
                                                                    Filter on
                                                                    field must
                                                                    be selected.
                                                                  </FormHelperText>
                                                                )}
                                                              </FormControl>
                                                            </div>
                                                            <div className="col-sm-4">
                                            <FormControl size="small" required>
                                              <InputLabel
                                                size="small"
                                                id={
                                                  'filterkeylabelOperator' + columnIndex + '_' +
                                                  filterIndex
                                                }
                                              >
                                                Operator
                                              </InputLabel>
                                              <Select
                                                size="small"
                                                required
                                                labelId={
                                                  'filterkeylabelOperator' + columnIndex + '_' +
                                                  filterIndex
                                                }
                                                id={
                                                  'filterKeySelectOperator' + columnIndex + '_' +
                                                  filterIndex
                                                }
                                                value={filter.operator}
                                                onChange={(event) => {
                                                  this.handleFilterChange(
                                                    event.target.value,
                                                    'operator',
                                                    columnIndex,
                                                    filterIndex
                                                  );
                                                }}
                                              >
                                                <MenuItem value="">
                                                  <em>None</em>
                                                </MenuItem>
                                                {Operators &&
                                                  Object.keys(Operators).map(
                                                    (key, i) => (
                                                      <MenuItem
                                                        size="small"
                                                        value={key}
                                                        key={'OperatorFilter' + columnIndex + '_' + filterIndex + '_' + i + key}
                                                      >
                                                        {key}
                                                      </MenuItem>
                                                    )
                                                  )}
                                              </Select>
                                            </FormControl>
                                          </div>

                                                            <div className="col-sm-4">
                                                              {this.getInputForKey(
                                                                filter.key,
                                                                columnIndex,
                                                                filterIndex,
                                                                filter.values
                                                              )}
                                                              {/* <ChipInput
                                                                                label='Filter On'
                                                                                defaultValue={filter.values}
                                                                                onChange={(chips) => this.handleFilterChange(chips, "key", columnIndex, filterIndex)}
                                                                            /> */}
                                                            </div>
                                                          </div>
                                                        </>
                                                      );
                                                    }
                                                  )}
                                                </fieldset>
                                            )}
                                          </div>
                                        </AccordionDetails>
                                      </Accordion>
                                    </>
                                  );
                                })}
                            </fieldset>
                        )}
                      </>
                  )}

                  {configuration.isMappingAvailable === true && chartConfig.widgetType !== 10 &&
  (
<fieldset className="col-sm-12">
                              <legend>
                                widget Data Mapping
                              </legend>

                                <div className="row">
                        <div className="col-sm-6">
                            <FormControl
                              size="small"
                              error={this.getErrorStatus('widgetDataMapping.attributeName')}
                            >
                              <InputLabel
                                size="small"
                                id={'columnwidgetDataMapping.attributeNamelabel'}
                              >
                                XAxis Field
                              </InputLabel>
                              <Select
                                required={true}
                                // error={((configuration.trend || {}).key||"")==""?true:false}
                                size="small"
                                labelId={'columnwidgetDataMapping.attributeNamelabel'}
                                id={'columnwidgetDataMapping.attributeNameSelect'}
                                error={this.getErrorStatus('widgetDataMapping.attributeName')}
                                value={
                                (configuration.widgetDataMapping || {}).attributeName
                              }
                              onChange={(event) => {
                                this.handleWidgetDataMappingChange(
                                  event.target.value,
                                  'attributeName'
                                );
                              }}
                              >
                                <MenuItem value="">
                                  <em>None</em>
                                </MenuItem>
                                {sampleData &&
                                  Object.keys(sampleData).map((key, ic) => {
                                    return (
                                      <MenuItem
                                        size="small"
                                        key={'WidgetDataMappingdrillDownConfigtrendKey' + ic}
                                        value={key}
                                      >
                                        {key}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                              {this.getErrorStatus('widgetDataMapping.attributeName') && (
                                <FormHelperText>
                                  XAxis field is required.
                                </FormHelperText>
                              )}
                            </FormControl>

                           </div>
                          <div className="col-sm-6">
                          <FormControl
                              size="small"
                              error={this.getErrorStatus('widgetDataMapping.attributeValue')}
                            >
                              <InputLabel
                                size="small"
                                id={'columnwidgetDataMapping.attributeValuelabel'}
                              >
                                XAxis Count Field
                              </InputLabel>
                              <Select
                                required={true}
                                // error={((configuration.trend || {}).key||"")==""?true:false}
                                size="small"
                                labelId={'columnwidgetDataMapping.attributeValuelabel'}
                                id={'columnwidgetDataMapping.attributeValueSelect'}
                                error={this.getErrorStatus('widgetDataMapping.attributeValue')}
                                value={
                                (configuration.widgetDataMapping || {}).attributeValue
                              }
                              onChange={(event) => {
                                this.handleWidgetDataMappingChange(
                                  event.target.value,
                                  'attributeValue'
                                );
                              }}
                              >
                                <MenuItem value="">
                                  <em>None</em>
                                </MenuItem>
                                {sampleData &&
                                  Object.keys(sampleData).map((key, ic) => {
                                    return (
                                      <MenuItem
                                        size="small"
                                        key={'DatamappingattributeValueKey' + ic}
                                        value={key}
                                      >
                                        {key}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                              {this.getErrorStatus('widgetDataMapping.attributeValue') && (
                                <FormHelperText>
                                  XAxis Count field is required.
                                </FormHelperText>
                              )}
                            </FormControl>

                            </div>
                       <div className="col-sm-6">
                          <FormControl
                              size="small"
                              error={this.getErrorStatus('widgetDataMapping.percentage')}
                            >
                              <InputLabel
                                size="small"
                                id={'columnwidgetDataMapping.percentage'}
                              >
                                XAxis Percent Field
                              </InputLabel>
                              <Select
                                required={true}
                                // error={((configuration.trend || {}).key||"")==""?true:false}
                                size="small"
                                labelId={'columnwidgetDataMapping.percentagelabel'}
                                id={'columnwidgetDataMapping.percentageSelect'}
                                error={this.getErrorStatus('widgetDataMapping.percentage')}
                                value={
                                (configuration.widgetDataMapping || {}).percentage
                              }
                              onChange={(event) => {
                                this.handleWidgetDataMappingChange(
                                  event.target.value,
                                  'percentage'
                                );
                              }}
                              >
                                <MenuItem value="">
                                  <em>None</em>
                                </MenuItem>
                                {sampleData &&
                                  Object.keys(sampleData).map((key, ic) => {
                                    return (
                                      <MenuItem
                                        size="small"
                                        key={'datamappingPercentageKey' + ic}
                                        value={key}
                                      >
                                        {key}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                              {this.getErrorStatus('widgetDataMapping.percentage') && (
                                <FormHelperText>
                                  XAxis percentage field is required.
                                </FormHelperText>
                              )}
                            </FormControl>

                           </div>
                        <div className="col-sm-6">
                           <FormControlLabel
                            id={'isShowDetailsOndemandLabel'}
                            key={'isShowDetailsOndemandLabelkey'}
                            value={configuration.showDetailsOndemand || false}
                            checked={configuration.showDetailsOndemand}
                            control={
                              <Checkbox
                                id={'isShowDetailsOndemandCheckbox'}
                                key={'isShowDetailsOndemandCheckbox'}
                                checked={configuration.showDetailsOndemand}
                                color="primary"
                                onChange={(event) => {
                                  this.handleConfigurationChange(
                                    event.target.checked,
                                    'showDetailsOndemand'
                                  );
                                }}
                              />
                            }
                            label="Show Details On Demand"
                            labelPlacement="end"
                          />
                        </div>
                         <div className="col-sm-6">
                           <FormControlLabel
                            id={'isShowPercentLabel'}
                            key={'isShowPercentLabelkey'}
                            value={configuration.showPercent || false}
                            checked={configuration.showPercent}
                            control={
                              <Checkbox
                                id={'isShowPercentCheckbox'}
                                key={'isShowPercentCheckbox'}
                                checked={configuration.showPercent}
                                color="primary"
                                onChange={(event) => {
                                  this.handleConfigurationChange(
                                    event.target.checked,
                                    'showPercent'
                                  );
                                }}
                              />
                            }
                            label="show Percentage with count"
                            labelPlacement="end"
                          />
</div>
                      </div>

                            </fieldset>

  )
                  }

                  {chartConfig.widgetType !== 3 && (
                    <>
                    <fieldset className="col-sm-12">
                              <legend>
                                Data Column
                                <Tooltip title="Add New Level">
                                  <IconButton
                                    aria-label={'addLevel'}
                                    size="small"
                                    onClick={this.handleAutoGenerateAddDataColumn}
                                  >
                                    <AddCircleOutline fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </legend>

                              {configuration.autoGenerate && configuration.autoGenerate.dataColumn &&
                                configuration.autoGenerate.dataColumn.map((column, index) => {
                                  const levelIndex = index;
                                  return (
                                    <>
                                      <Accordion>
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls={
                                            'data-Level-content' + index
                                          }
                                          id={'data-level-panel-header' + index}
                                        >
                                          <Typography>
                                            <Tooltip title="Delete">
                                              <IconButton
                                                aria-label={
                                                  'Dataleveldelete' + levelIndex
                                                }
                                                size="small"
                                                onClick={() =>
                                                  this.handleAutoGenerateDeleteDataColumn(levelIndex)
                                                }
                                              >
                                                <DeleteIcon
                                                  style={{
                                                    color:
                                                      'var(--common--Text--color)'
                                                  }}
                                                  fontSize="small"
                                                />
                                              </IconButton>
                                            </Tooltip>{' '}
                                            &nbsp;Data column {index + 1}
                                           </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                          <div className="row col-sm-12">
                                            <div className="col-sm-3 col-xs-12">
                                            <FormControl size="small" required>
                                              <InputLabel
                                                size="small"
                                                id={
                                                  'autoGeneratefilterdatakeylabelOperator' +
                                                  levelIndex
                                                }
                                              >
                                                Operator
                                              </InputLabel>
                                              <Select
                                                size="small"
                                                required
                                                labelId={
                                                  'autoGeneratefilterdatakeylabelOperator' +
                                                  levelIndex
                                                }
                                                id={
                                                  'autoGeneratefilterdataKeySelectOperator' +
                                                  levelIndex
                                                }
                                                value={column.operator}
                                                onChange={(event) => {
                                                  this.handleAutoGenerateDataColumnChange(
                                                    event.target.value,
                                                    'operator',
                                                    levelIndex
                                                  );
                                                }}
                                              >
                                                <MenuItem value="">
                                                  <em>None</em>
                                                </MenuItem>
                                                {DataOperators &&
                                                  Object.keys(DataOperators).map(
                                                    (key, i) => (
                                                      <MenuItem
                                                        size="small"
                                                        value={key}
                                                        key={'DataColumnOperator' + i + key}
                                                      >
                                                        {key}
                                                      </MenuItem>
                                                    )
                                                  )}
                                              </Select>
                                            </FormControl>
                                          </div>
                                              <div className="col-sm-3 col-xs-12">
                            <FormControl
                              size="small"
                              error={this.getdataColumnErrorStatus('key', levelIndex)}
                            >
                              <InputLabel
                                size="small"
                                id={'datacolumnconfigkeylabel'}
                              >
                                on Field
                              </InputLabel>
                              <Select
                                required={true}
                                // error={((configuration.trend || {}).key||"")==""?true:false}
                                size="small"
                                labelId={'dataColumnconfigkeylabel'}
                                id={'dataColumnconfigKeySelect'}
                                error={this.getdataColumnErrorStatus('key', levelIndex)}
                                helperText={
                                  this.getdataColumnErrorStatus('key', levelIndex) &&
                                  'On field is required.'
                                }
                                value={
                                  (column || {}).key}
                                onChange={(event) => {
                                  this.handleAutoGenerateDataColumnChange(
                                    event.target.value,
                                    'key',
                                    levelIndex
                                  );
                                }}
                              >
                                <MenuItem value="">
                                  <em>None</em>
                                </MenuItem>
                                {sampleData &&
                                  Object.keys(sampleData).map((key, ic) => {
                                    return (
                                      <MenuItem
                                        size="small"
                                        key={'dataColumnConfigtrendKey' + ic}
                                        value={key}
                                      >
                                        {key}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                              {this.getdataColumnErrorStatus('key', levelIndex) && (
                                <FormHelperText>
                                  On field is required.
                                </FormHelperText>
                              )}
                            </FormControl>
                                            </div>
                                            <div className="col-sm-3 col-xs-12">
 <TextField
                            size="small"
                            id="title"
                            error={this.getdataColumnErrorStatus('title')}
                            helperText={
                              this.getdataColumnErrorStatus('title') &&
                              'Title is mandatory'
                            }
                            value={
                                  (column || {}).title}
                                onChange={(event) => {
                                  this.handleAutoGenerateDataColumnChange(
                                    event.target.value,
                                    'title',
                                    levelIndex
                                  );
                                }}
                            label={'Title'}
                          />
                                          </div>
                                           <div className="col-sm-3 col-xs-12">
                            <FormControl
                              size="small"
                              error={this.getdataColumnErrorStatus('format', levelIndex)}
                            >
                              <InputLabel
                                size="small"
                                id={'datacolumnformatconfigkeylabel'}
                              >
                                Format
                              </InputLabel>
                              <Select
                                required={true}
                                // error={((configuration.trend || {}).key||"")==""?true:false}
                                size="small"
                                labelId={'dataColumnformatconfigkeylabel'}
                                id={'dataColumnformatconfigKeySelect'}
                                error={this.getdataColumnErrorStatus('format', levelIndex)}
                                helperText={
                                  this.getdataColumnErrorStatus('format', levelIndex) &&
                                  'On field is required.'
                                }
                                value={
                                  (column || {}).key}
                                onChange={(event) => {
                                  this.handleAutoGenerateDataColumnChange(
                                    event.target.value,
                                    'format',
                                    levelIndex
                                  );
                                }}
                              >
                                <MenuItem value="">
                                  <em>None</em>
                                </MenuItem>
                                {DataFormat &&
                                  Object.keys(DataFormat).map((key, ic) => {
                                    return (
                                      <MenuItem
                                        size="small"
                                        key={'dataColumnConfigtrendKey' + ic}
                                        value={key}
                                      >
                                        {key}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                              {this.getdataColumnErrorStatus('format', levelIndex) && (
                                <FormHelperText>
                                  On field is required.
                                </FormHelperText>
                              )}
                            </FormControl>
                                            </div>
                                          </div>
                                        </AccordionDetails>
                                      </Accordion>
                                    </>
                                  );
                                })}
                            </fieldset>
                    <fieldset className="col-sm-12">
                              <legend>
                                Drilldown config
                                <Tooltip title="Add New Level">
                                  <IconButton
                                    aria-label={'addLevel'}
                                    size="small"
                                    onClick={this.addNewLevel}
                                  >
                                    <AddCircleOutline fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </legend>

                              {configuration.drillDownConfig &&
                                configuration.drillDownConfig.map((level, index) => {
                                  const levelIndex = index;
                                  return (
                                    <>
                                      <Accordion>
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls={
                                            'Level-content' + index
                                          }
                                          id={'level-panel-header' + index}
                                        >
                                          <Typography>
                                            <Tooltip title="Delete">
                                              <IconButton
                                                aria-label={
                                                  'leveldelete' + levelIndex
                                                }
                                                size="small"
                                                onClick={() =>
                                                  this.deleteLevel(levelIndex)
                                                }
                                              >
                                                <DeleteIcon
                                                  style={{
                                                    color:
                                                      'var(--common--Text--color)'
                                                  }}
                                                  fontSize="small"
                                                />
                                              </IconButton>
                                            </Tooltip>{' '}
                                            &nbsp;Level {index + 1}
                                           </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                          <div className="row col-sm-12">
                                              <div className="col-sm-6">
                            <FormControl
                              size="small"
                              error={this.getdrillDownConfigErrorStatus('key', levelIndex)}
                            >
                              <InputLabel
                                size="small"
                                id={'columndrillconfigkeylabel'}
                              >
                                on Field
                              </InputLabel>
                              <Select
                                required={true}
                                // error={((configuration.trend || {}).key||"")==""?true:false}
                                size="small"
                                labelId={'columndrillconfigkeylabel'}
                                id={'columndrillconfigKeySelect'}
                                error={this.getdrillDownConfigErrorStatus('key', levelIndex)}
                                helperText={
                                  this.getdrillDownConfigErrorStatus('key', levelIndex) &&
                                  'On field is required.'
                                }
                                value={
                                  (level || {}).key}
                                onChange={(event) => {
                                  this.handleDrillDownChange(
                                    event.target.value,
                                    'key',
                                    levelIndex
                                  );
                                }}
                              >
                                <MenuItem value="">
                                  <em>None</em>
                                </MenuItem>
                                {sampleData &&
                                  Object.keys(sampleData).map((key, ic) => {
                                    return (
                                      <MenuItem
                                        size="small"
                                        key={'drillDownConfigtrendKey' + ic}
                                        value={key}
                                      >
                                        {key}
                                      </MenuItem>
                                    );
                                  })}
                              </Select>
                              {this.getdrillDownConfigErrorStatus('key', levelIndex) && (
                                <FormHelperText>
                                  On field is required.
                                </FormHelperText>
                              )}
                            </FormControl>
                                            </div>
                                            <div className="col-sm-6">
 <TextField
                            size="small"
                            id="title"
                            error={this.getdrillDownConfigErrorStatus('title')}
                            helperText={
                              this.getdrillDownConfigErrorStatus('title') &&
                              'Title is mandatory'
                            }
                            value={
                                  (level || {}).title}
                                onChange={(event) => {
                                  this.handleDrillDownChange(
                                    event.target.value,
                                    'title',
                                    levelIndex
                                  );
                                }}
                            label={'Title'}
                          />
                                          </div>
                                          </div>
                                        </AccordionDetails>
                                      </Accordion>
                                    </>
                                  );
                                })}
                            </fieldset>
</>
                  )}

                  <fieldset className="col-sm-12">
                              <legend>
                                Ignore Columns for Details
                    </legend>
                    <div className="row">
                      <div className="col-lg-12">
                        <TextareaAutosize
                  aria-label={'ignoreColumn'}
                  label={'Ignore Column Label'}
                  rowsMin={3}
                  style={{ width: '100%' }}
                  value={configuration.ignoreColumns}
                      placeholder="ignoreColumnLabel"
                      onChange={(e) => {
                        this.handleConfigurationChange(
                          e.target.value,
                          'ignoreColumns'
                        );
                      }}
                />
                      </div>
                    </div>
                    </fieldset>
                </div>

                <br></br>
                <div className="col-sm-12">
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={this.handlePreviewClickOpen}
                  >
                    Preview & save
                  </Button>
                </div>
                <Dialog
                  onClose={this.handlePreviewClose}
                  aria-labelledby="responsive-dialog-title"
                  open={openPreview}
                  fullWidth={true}
                  maxWidth={'md'}
                  PaperComponent={PaperComponent}
                >
                  <DialogTitle
                    style={{ cursor: 'move' }}
                    id="responsive-dialog-title"
                    onClose={this.handlePreviewClose}
                  >
                    Preview & Save
                  </DialogTitle>
                  <DialogContent dividers>
                    {openPreview && (
                      <>
                        {' '}
                        <span>Note: Preview is based on sample data.</span>
                        {
                          <div
                            style={{ height: '400px' }}
                            id="previewContainer_chart"
                          >
                            <RenderLayout
                              // propertyId={param.propertyId}
                              key={
                                'widget' +
                                chartConfig.usersWidgetMappingID +
                                chartConfig.widgetId
                              }
                              startDate={param.startDate}
                              endDate={param.endDate}
                              widgetconfig={chartConfig}
                              IsInPreviewMode={true}
                              OpenWidgetConfigurationPanel={
                                this.OpenWidgetConfigurationPanel
                              }
                            ></RenderLayout>
                          </div>
                        }
                      </>
                    )}
                  </DialogContent>
                  <DialogActions>
                    {chartConfig.isClone !== true && (
                      <Button
                        autoFocus
                        onClick={() => {
                          this.handlePreviewClose();
                          this.props.onSaveConfiguration(chartConfig);
                        }}
                        color="primary"
                      >
                        Save changes
                      </Button>
                    )}
                    {this.props.configureMaster !== true && (
                      <Button
                        autoFocus
                        onClick={this.handleConfirmPreviewClickOpen}
                        color="primary"
                      >
                        Save As New
                      </Button>
                    )}
                    <Button
                      autoFocus
                      onClick={this.handlePreviewClose}
                      color="primary"
                    >
                      Cancel
                    </Button>
                  </DialogActions>
                </Dialog>

                <Dialog
                  onClose={this.handleConfirmPreviewClose}
                  key="customized-Confirm-dialog"
                  aria-labelledby="customized-Confirm-dialog-title"
                  open={openConfirmPreview}
                  fullWidth={true}
                  maxWidth={'sm'}
                >
                  <DialogTitle
                    id="customized-Confirm-dialog-title"
                    onClose={this.handleConfirmPreviewClose}
                  >
                    Preview & Save
                  </DialogTitle>
                  <DialogContent dividers>
                    <p>Are you sure you want to save this as new widget?</p>
                    <TextField
                      id="title"
                      defaultValue={chartConfig.title || masterConfig.name}
                      onChange={(event) => {
                        this.handleChange(event.target.value, 'title');
                      }}
                      label="Override Title"
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button
                      autoFocus
                      onClick={() => {
                        chartConfig.usersWidgetMappingID = 0;
                        this.props.onSaveConfiguration(chartConfig);
                        this.setState({
                          openConfirmPreview: false,
                          openPreview: false
                        });
                      }}
                      color="primary"
                    >
                      Submit
                    </Button>

                    <Button
                      autoFocus
                      onClick={this.handleConfirmPreviewClose}
                      color="primary"
                    >
                      Cancel
                    </Button>
                  </DialogActions>
                </Dialog>

                <Dialog
                  fullScreen={false}
                  open={openViewSampleDataPanel}
                  maxWidth="lg"
                  onClose={this.handleSampleDataViewClose}
                  aria-labelledby="responsive-dialog-title"
                  PaperComponent={PaperComponent}
                >
                  <DialogTitle id="responsive-dialog-title">
                    Sample Data
                  </DialogTitle>
                  <DialogContent>
                    {sampleViewData && (
                      <GridTable
                        {...GetPropsForData(
                          'details',
                          sampleViewData,
                          chartConfig,
                          null
                        )}
                        config={{ pagination: true }}
                      ></GridTable>
                    )}
                  </DialogContent>
                </Dialog>
              </form>
            </div>
          </>
        )}
      </div>
    );
  }
}

export default Widget;
